module.exports = __webpack_public_path__ + "static/img/logo-w.beb70386.png";